import copy from "../../../copy/en/admin-workspace.json" with { type: "json" };
import { Link, Outlet, useLocation } from "react-router";
import { useMe } from "../../auth/MeProvider.js";
import { Mail, Settings2, Users, Wrench } from "lucide-react";
import { SubNav, useActiveTabIndicator } from "../../components/ui/Tabs.js";
import { adminGroups, adminSectionActive } from "./adminNavigation.js";
import "./adminWorkspace.css";
export * from "./adminNavigation.js";

export function AdminLayout() {
  const { me, hasCap } = useMe();
  const { pathname, search } = useLocation();
  const canManage = hasCap("users:manage");
  const canOrg = hasCap("org:manage");
  const groups = adminGroups({ canManage, canOrg, canZoom: me?.role === "admin" && hasCap("integrations:manage") && hasCap("reps:read") });
  const active = groups.find(group => group.sections.some(section => adminSectionActive(section, pathname, search))) ?? groups[0];
  const groupTabs = useActiveTabIndicator<HTMLElement>(active?.id, '[aria-current="location"]');
  const groupIcons = { people: Users, email: Mail, configuration: Settings2, advanced: Wrench };
  return (
    <section className="admin-workspace">
      <header className="admin-workspace__heading"><h1>{copy.title}</h1></header>
      <nav ref={groupTabs} className="section-tabs" aria-label={copy.groupsLabel}>
        {groups.map(group => { const Icon = groupIcons[group.id as keyof typeof groupIcons]; return <Link key={group.id} to={group.sections[0]!.to}
          aria-current={active?.id === group.id ? "location" : undefined}
          className="section-tab">{Icon ? <Icon className="section-tab__icon" aria-hidden="true" /> : null}{group.label}</Link>; })}
      </nav>
      {active ? <SubNav secondary ariaLabel={copy.sectionsLabel} items={active.sections.map(section => ({ ...section, active: adminSectionActive(section, pathname, search) }))} /> : null}
      <div className="admin-workspace__content"><Outlet /></div>
    </section>
  );
}
